/* eslint-disable no-underscore-dangle */
import React, {
  memo, useCallback, useContext,
} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';
import { AppContext } from '../../../../../providers/authProvider';
import api from '../../../../../api/req';
import { StyledButton, StyledImg, StyledText } from '../../../../../components/Styled/Buttons/styledCommandPanelButton';
import { DraftIcon } from '../../../../../components/Styled/Buttons/icons';

const defaultRecord = () => ({
  date: new Date().toJSON().slice(0, 10),
  order_amount: 0,
});

function LandsFill({
  onChange, members, payer,
  // lands,
}) {
  const { auth } = useContext(AppContext);

  const loadLands = useCallback(
    async () => {
      const dateReq = { members, head_house: payer.id };
      const r = await api.post('/api/household/landsfill/', auth, dateReq);
      if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
      return r.json();
    },
    [auth, members, payer],
  );
  const onLandsFill = useCallback(
    (e) => {
      loadLands()
        .then((d) => {
          // eslint-disable-next-line array-callback-return
          // const tpId = lands.reduce((landId, el) => [
          //   ...landId,
          //   el.land.id,
          // ], []);
          // eslint-disable-next-line array-callback-return,consistent-return
          // const resLands = d.reduce((res, el) => {
          //   const srvId = el.land.id;
          //   if (!tpId.includes(srvId)) {
          //     return [
          //       ...res,
          //       el,
          //     ];
          //   }
          // }, []);

          onChange(
            e,
            //     [
            //   ...lands,
            //   ...resLands,
            // ]
            d,
          );
        });
    },
    [loadLands, onChange],
  );
  return (
    <StyledButton
      title="Заповнити земельними ділянками, власниками/орендарями яких, є члени домогостодарства"
      onClick={onLandsFill}
    >
      <StyledImg src={DraftIcon} alt="Заповнити земельними ділянками" />
      <StyledText>Заповнити земельними ділянками</StyledText>
    </StyledButton>
  );
}

function LandsTablePart({
  data, members, options, onChange, readOnly, payer,
}) {
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage,
  } = useTablePart({
    data, options, onChange, readOnly, defaultRecord,
  });

  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      >
        <LandsFill
          onChange={onChange}
          members={members}
          lands={data}
          payer={payer}
        />
      </TPCommandPanel>

      <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                {fields.land.label}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row) => (
              <Row
                actions={actions}
                row={row}
                readOnly={readOnly}
                fields={fields}
                key={row.id}
                active={activeRow === row.id}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

LandsTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,

  members: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,

  payer: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,

  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};

LandsTablePart.defaultProps = {
  readOnly: false,
};

LandsFill.propTypes = {
  onChange: PropTypes.func.isRequired,
  members: PropTypes.arrayOf(PropTypes.shape([
  ])).isRequired,
  // lands: PropTypes.arrayOf(PropTypes.shape({
  // })).isRequired,

  payer: PropTypes.shape({ id: PropTypes.number }).isRequired,
};

export default memo(LandsTablePart);
